(function() {
	'use strict';

	angular
		.module('components')
		.component('estimatedNotice', {
			bindings: {},
			restrict: 'E',
			templateUrl: '/scripts/components/estimated-notice/estimated-notice-component.html'
		});
})();